import { useApplicationsApplicationidGetQuery } from 'api/customPortalApi';

import useBorrowerData from './useBorrowerData';
import { useLayoutLoading } from './useLayoutLoading';

export const useApplicationData = () => {
  const { borrower, isLoading: borrowerLoading } = useBorrowerData();

  const {
    data: application,
    isLoading: applicationLoading,
    isFetching: applicationFetching,
  } = useApplicationsApplicationidGetQuery(
    {
      params: { applicationId: borrower?.borrower.activeApplication?.id! },
    },
    { skip: !borrower?.borrower.activeApplication?.id },
  );

  useLayoutLoading(applicationLoading, applicationFetching, borrowerLoading);

  return {
    borrower: borrower?.borrower,
    application: application?.application,
    applicationLoading,
    applicationFetching,
    borrowerLoading,
  };
};
